import { render, staticRenderFns } from "./UserProduct.vue?vue&type=template&id=6975963b&"
import script from "./UserProduct.vue?vue&type=script&lang=js&"
export * from "./UserProduct.vue?vue&type=script&lang=js&"
import style0 from "./UserProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports